<style scoped>
  .uplod-list {
    font-size: 14px;
  }
  .uplod-list li{
    padding: 2px 0 2px 20px;
    background: url('../../assets/images/iconfont-20.png') no-repeat 0 center;
    background-size: 15px 15px;
  }

  .uplod-list span {
    padding-right: 16px;
  }

  .uplod-list-delete {
    color: red;
    cursor: pointer;
  }
</style>
<template>
  <div>
    <ul class="uplod-list">
      <li v-for="(item,index) in fileList" :key="index">
        <span>{{item.name}}</span>
        <span>{{item.percentage}}%</span>
        <span class="uplod-list-delete" @click="handleClick(item.name,index)">删除</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      fileList: {
        type: [Array, Object],
        default: {}
      },
      delete:Function
    },
    methods: {
      handleClick(name, index) {
        this.delete(name, index)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Upload/UploadList.vue